import * as _ from 'lodash'

//-- Use this index type when you know one item will exist at a key

export interface IdxNode<ItemType> {
    [id:string]: ItemType | IdxNode<ItemType>
}




export class Index<ItemType> {


    private arrIndexer: (string | ((t: ItemType) => string))[]
    private bStoreMultiple: boolean
    private dctValue: ItemType | ItemType[] | IdxNode<ItemType | ItemType[]>
    private dctKeys: string[] | IdxNode<string[]>
    private addOrder: {value: (ItemType | ItemType[]), keys: string[]}[]

    constructor(arrIndexers: (string | ((t: ItemType) => string))[], bStoreMultiple?: boolean) {
        this.arrIndexer = arrIndexers
        this.bStoreMultiple = !!bStoreMultiple
        this.dctValue = undefined
        this.dctKeys = undefined
        this.addOrder = []
    }

    clear(): void {
        this.dctValue = undefined
        this.dctKeys = undefined
        this.addOrder = []
    }

    add(anItem: ItemType, bSkipIfKeyPresent?: boolean): boolean {
        //--
        if(_.isEmpty(this.arrIndexer)){
            if(_.isUndefined(this.dctValue)){
                if(this.bStoreMultiple)
                    this.dctValue = [anItem]
                else
                    this.dctValue = anItem
                this.dctKeys = []
                this.addOrder = [{value: this.dctValue, keys: []}]
                return true
            }

            if(bSkipIfKeyPresent)
                return false

            if(this.bStoreMultiple){
                // @ts-expect-error "multi type"
                this.dctValue.push(anItem)
            } else
                this.dctValue = anItem
            // @ts-expect-error "multi type"
            this.addOrder = [{value: this.dctValue, keys: []}]
            this.dctKeys = []
            return true
        }


        const arrKeys = this.getKeys(anItem)
        this.dctKeys = this.dctKeys || {}
        this.dctValue = this.dctValue || {}

        let dctK = this.dctKeys
        let dctV = this.dctValue
        const lastIdx = arrKeys.length - 1

        for(const idx in arrKeys){
            const key = arrKeys[idx]
            if(+idx == lastIdx){
                // @ts-expect-error "multiple types"
                dctK[key] = arrKeys

                if(this.bStoreMultiple){
                    // @ts-expect-error "multiple types"
                    if(_.isArray(dctV[key])) {
                        // @ts-expect-error "multiple types"
                        dctV[key].push(anItem)
                    } else {
                        // @ts-expect-error "multiple types"
                        dctV[key] = [anItem]
                        // @ts-expect-error "multiple types"
                        this.addOrder.push({value: dctV[key], keys: arrKeys})
                    }
                } else  {
                    // @ts-expect-error "multiple types"
                    dctV[key] = anItem
                    this.addOrder.push({value: anItem, keys: arrKeys})
                }

            } else {
                if(!(key in dctK))
                    {
                        // @ts-expect-error "multiple types"
                        dctK[key] = {}
                    }

                // @ts-expect-error "multiple types"
                if(!(key in dctV))
                    {
                        // @ts-expect-error "multiple types"
                        dctV[key] = {}
                    }

                // @ts-expect-error "multiple types"
                dctK = dctK[key]
                // @ts-expect-error "multiple types"
                dctV = dctV[key]
            }
        }

        return true

    }

    get(arrKeys: string[]): ItemType | ItemType[] {
        //--
        if(_.isEmpty(this.arrIndexer))
            return <ItemType> this.dctValue

        if(arrKeys.length != this.arrIndexer.length){
            // Key could mismatch
            throw `Key Length Mismatch: ${arrKeys?.length} != ${this.arrIndexer.length}.`
        }


        let current = this.dctValue
        const lastIdx = (this.arrIndexer.length - 1)
        for(const idx in arrKeys){
            const key = arrKeys[idx]
            if(_.isEmpty(current))
                return undefined

            if(+idx == lastIdx)
                return (<any> current)[key]

            current = (<any> current)[key]
        }

        return undefined
    }

    forEach(fnc: ((t: ItemType | ItemType[], arrKeys: string[]) => boolean | void)){

        //--- Check the simple case
        if(_.isEmpty(this.arrIndexer)){
            if(_.isEmpty(this.dctValue))
                return
            // Only one iteration
            // @ts-expect-error "multiple types"
            fnc(this.dctValue, [])
            return
        }

        //-- Iterate over the keys
        const depthLast = this.arrIndexer.length
        let bDone = false
        function rForEach(pDctValue: ItemType| ItemType[] | IdxNode<ItemType | ItemType[]>,
                          pDctKeys: string[] | IdxNode<string[]>,
                          cDepth: number)
        {
            let dctValue = pDctValue
            let dctKeys = pDctKeys
            const bRecurse = (cDepth < depthLast)

            // @ts-expect-error "multiple types"
            _.forEach(dctValue, (value, key) => {
                if(bDone)
                    return true // stop iterating

                // @ts-expect-error "multiple types"
                const dctKeysNxt = dctKeys[key]
                if(bRecurse){
                    rForEach(value, dctKeysNxt, cDepth + 1)
                } else {
                    const b = fnc(<ItemType>value, <string[]>dctKeysNxt)
                    if(b && _.isBoolean(b))
                        bDone = true
                }

            })

        }


        rForEach(this.dctValue, this.dctKeys,1)

    }

    forEachAddOrder(fnc: ((t: ItemType | ItemType[], arrKeys: string[]) => boolean | void)) {
        _.forEach(this.addOrder, (ao) => {
            return fnc(ao.value, ao.keys)
        })
    }

    remove(deleteFnc: ((t: ItemType | ItemType[], arrKeys: string[]) => boolean)){
        let itemsToRemove: (ItemType | ItemType[])[] = []
        let itemKeysToRemove: (string[])[] = []

        this.forEach((item, arrKeys) => {
            if(deleteFnc(item, arrKeys)){
                itemKeysToRemove.push(arrKeys)
                itemsToRemove.push(item)
            }
        })
        _.forEach(itemKeysToRemove, (arrKeys) => {
            Index.removeFromIndex(this.dctValue, arrKeys)
            Index.removeFromIndex(this.dctKeys, arrKeys)
        })
    }

    //--
    getKeys(nd: ItemType): string[] {
        let returnValue: string[] = []

        _.forEach(this.arrIndexer, (anIndexer) => {
            let keyValue
            if(_.isFunction(anIndexer))
                keyValue = anIndexer(nd)
            else
                keyValue = (<any> nd)[anIndexer]

            returnValue.push(keyValue)
        })

        return returnValue
    }

    values(): (ItemType | ItemType[])[] {
        let rv: (ItemType | ItemType[])[] = []

        this.forEach((a) => { rv.push(a)  })

        return rv
    }
    static placeInIndex(dct: any, arrKeys: string[], node: any, bSkipIfKeyPresent?: boolean): boolean {

        if(_.isEmpty(arrKeys))
            return

        if(_.isUndefined(dct))
            return

        let dctV = dct
        let lastIdx = arrKeys.length - 1

        for(let idx in arrKeys){
            let key = arrKeys[idx]
            if(+idx == lastIdx) {
                if(!_.isEmpty(dctV[key]) && bSkipIfKeyPresent)
                    return false

                dctV[key] = node
            } else {

                if(!(key in dctV))
                    dctV[key] = {}

                dctV = dctV[key]
            }
        }

        return true

    }

    static getFromIndex(dct: any, arrKeys: string[]): any {

        if(_.isEmpty(arrKeys))
            return dct

        let dctV = dct
        let lastIdx = arrKeys.length - 1

        for(let idx in arrKeys) {
            let key = arrKeys[idx]

            if (+idx == lastIdx)
                return dctV[key]
            else {

                if (!(key in dctV))
                    return undefined

                dctV = dctV[key]
            }
        }

    }

    static removeFromIndex(dct: any, arrKeys: string[]): any {

        if(_.isEmpty(arrKeys))
            return dct

        let dctV = dct
        const lastIdx = arrKeys.length - 1

        for(let idx in arrKeys) {
            const key = arrKeys[idx]

            if (+idx == lastIdx)
                delete dctV[key]
            else {

                if (!(key in dctV))
                    return undefined

                dctV = dctV[key]
            }
        }

    }

    }
